const utils = {
  //去掉对象中的空值属性，查询条件对象的使用场景，有值就传，无值不传
  filterEmptyValues: function (obj) {
    Object.fromEntries(
      Object.entries(obj).filter(
        ([, v]) => v != null && v != null && v != undefined
      )
    );
    return obj;
  },
  //格式化日期
  formatDate: function (date, formatString = "YYYY-MM-DD") {
    // 创建一个 Date 对象（如果传入的 date 不是 Date 对象）
    date = new Date(date);
    // 定义格式映射
    const formatMap = {
      YYYY: date.getFullYear(),
      MM: String(date.getMonth() + 1).padStart(2, "0"),
      DD: String(date.getDate()).padStart(2, "0"),
      HH: String(date.getHours()).padStart(2, "0"),
      mm: String(date.getMinutes()).padStart(2, "0"),
      ss: String(date.getSeconds()).padStart(2, "0"),
    };

    // 替换格式字符串中的占位符
    return formatString.replace(
      /YYYY|MM|DD|HH|mm|ss/g,
      (match) => formatMap[match]
    );
  },

  getNextDays: function(days) {
    days = !days ? 5 : days;
    const dates = [];
    const today = new Date();
    const weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
    console.log(10)

    for (let i = 0; i < days; i++) {
      const current = new Date(today);
      current.setDate(today.getDate() + i);

      // 获取年、月、日（月和日需要补零）
      //const year = current.getFullYear();
      //const month = String(current.getMonth() + 1).padStart(2, "0"); // 月份从0开始，需+1，再补零
      //const day = String(current.getDate()).padStart(2, "0"); // 日期补零

      const fullDateStr = this.formatDate(current)
      const shortDateStr = this.formatDate(current,"MM-DD")

      let label;
      if (i === 0) {
        label = "今天";
      } else if (i === 1) {
        label = "明天";
      } else {
        label = weekDays[current.getDay()];
      }

      dates.push({
        label: label,
        shortDateStr: shortDateStr,
        fullDateStr: fullDateStr,//`${year}-${month}-${day}`, // 格式化为 YYYY-MM-DD
        dateObj: current,
      });
    }
    return dates;
  },
}

export default utils;
